import { render, staticRenderFns } from "./ForgotEmailModal.vue?vue&type=template&id=155d0151&scoped=true"
import script from "./ForgotEmailModal.vue?vue&type=script&lang=js"
export * from "./ForgotEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d0151",
  null
  
)

export default component.exports